import React from 'react';
import pt from 'prop-types';
import { createPortal } from 'react-dom';
import SidebarPanel from 'components/storefront/editor/widgets/sidebar-panel';
import Button from 'components/button';
import Icon from 'components/icon';
import { EasyblocksBackendContext } from 'components/storefront/editor/backendContext';
import { getFormValues, changeFormValues } from './utils/easyblocks';

const PRESENTATIONAL_STYLE_FIELD_TYPES = [
  'color',
  'color_scheme',
  'color_scheme_group',
  'select',
  'radio',
  'checkbox',
  'number',
  'integer',
  'font',
];

export default class ThemePresetStyles extends React.PureComponent {
  static contextType = EasyblocksBackendContext;

  static propTypes = {
    presets: pt.array,
  };

  constructor(props) {
    super(props);
    this.state = {
      initialValue: getFormValues(),
      showPanel: false,
      selectedOption: null,
    };
  }

  resetInitialValues() {
    const { selectedOption, initialValue } = this.state;

    if (selectedOption) {
      changeFormValues(initialValue);
    }
  }

  onClickPanel = () => {
    const { showPanel } = this.state;
    this.setState({ showPanel: !showPanel, selectedOption: null });
  };

  onClosePanel = () => {
    this.setState({ showPanel: false });
  };

  onSave = () => {
    this.setState({ showPanel: false });
  };

  onCancel = () => {
    this.resetInitialValues();
  };

  updateEditorSettings(presetLabel) {
    const { presets } = this.props;
    const { editorConfig } = this.context;

    const editorSettings = editorConfig.globals.configs.editor?.settings;
    const presetSettings = presets.find(
      (preset) => preset.label === presetLabel,
    )?.settings;

    if (!editorSettings?.length || !presetSettings) {
      return;
    }

    const formValues = getFormValues();
    const editorFields = editorSettings.reduce((acc, settingGroup) => {
      acc.push(...settingGroup.fields);
      return acc;
    }, []);

    const updateValues = editorFields.reduce((acc, field) => {
      if (!PRESENTATIONAL_STYLE_FIELD_TYPES.includes(field.type)) {
        return acc;
      }

      const formValue = formValues[field.id];
      const presetValue = presetSettings[field.id];

      acc[field.id] = {
        ...formValue,
        value: presetValue,
      };

      return acc;
    }, {});

    changeFormValues(updateValues);
  }

  onClickStyleOption = (event) => {
    const { label } = event.currentTarget.dataset;

    this.setState({ selectedOption: label });

    this.updateEditorSettings(label);
  };

  renderPresetStyleOptions() {
    const { presets } = this.props;
    const { selectedOption } = this.state;

    return (
      <div className="storefront-editor--theme-preset-styles--options">
        {presets.map((preset, index) => (
          <Button
            type="secondary"
            size="sm"
            key={index}
            onClick={this.onClickStyleOption}
            data-label={preset.label}
          >
            {preset.label}
            {selectedOption === preset.label && <Icon fa="check" />}
          </Button>
        ))}
      </div>
    );
  }

  render() {
    const { showPanel } = this.state;

    return (
      <div className="storefront-editor--theme-preset-styles">
        <div
          className="fields-builder__FieldsGroupLabel"
          onClick={this.onClickPanel}
        >
          Theme style
        </div>
        {showPanel &&
          createPortal(
            <SidebarPanel
              title="Theme style"
              onSave={this.onSave}
              onCancel={this.onCancel}
              onClose={this.onClosePanel}
              value={this.state.value}
            >
              {this.renderPresetStyleOptions()}
              <div className="storefront-editor--theme-preset-styles--notice">
                Changing your theme style will affect the settings and look of
                your store. Some settings will be lost, but your content will
                not be affected.
              </div>
            </SidebarPanel>,
            document.getElementById('sidebar-panels-root'),
          )}
      </div>
    );
  }
}
